import { useDispatch } from "react-redux";
import { ToastContainer, Toast } from "react-bootstrap";
import { updateToastData } from "@features/toastSlice";
import { IToast } from "@ts/common-types";
import { FaCheckCircle, FaTimesCircle} from "react-icons/fa";
import { BsPatchExclamation } from "react-icons/bs";

const CustomToast: React.FC<IToast> = ({ toastData }) => {
    const dispatch = useDispatch();
    const { type, text, show } = toastData;

    const toastCloseHandler = () => {
        dispatch(
            updateToastData({
                type: "",
                text: "",
                show: false,
            })
        );
    };

    const getToastIcon = (type:string) => {
        const className = `custom-toast-icon text-${type}`;

        switch (type) {
            case "success":
                return <FaCheckCircle className={className}/>;
            case "danger":
                return <FaTimesCircle className={className}/>;
            case "warning":
                return <BsPatchExclamation className={className}/>;
            default:
                return <BsPatchExclamation className={className}/>;
        }
    }

    return (
        <>
            <div
                aria-live="polite"
                aria-atomic="true"
                style={{
                    position: "relative",
                    minHeight: "200px",
                    zIndex: "10001",
                }}
            >
                <ToastContainer
                    style={{
                        position: "fixed",
                        top: "10px",
                        left: "calc( 50% - 174px )",
                    }}
                >
                    <Toast
                        onClose={toastCloseHandler}
                        show={show}
                        delay={3000}
                        autohide
                    >
                        <Toast.Body>
                            <div
                                className="d-flex"
                                style={{
                                    background: "rgba(var(--bs-light),0.8)",
                                    placeItems: "center",
                                }}
                            >
                                {getToastIcon(type)}
                                <div className="toast-body" style={{width: "260px"}}> {text} </div>
                                <button
                                    type="button"
                                    className="btn-close btn-close-dark me-2 m-auto "
                                    data-bs-dismiss="toast"
                                    aria-label="Close"
                                    onClick={toastCloseHandler}
                                ></button>
                            </div>
                        </Toast.Body>
                    </Toast>
                </ToastContainer>
            </div>
        </>
    );
};

export default CustomToast;
